import React,{Component} from 'react';
import Showcase from '../../components/Sections/Showcase/Showcase';
import About from '../../components/Sections/About/About';
import Auxi from '../../hoc/Auxi/Auxi';
import Experience from '../../components/Sections/Experience/Experience';
import PersonalProjects from '../../components/Sections/PersonalProjects/PersonalProjects';
import CommercialProjects from '../../components/Sections/CommercialProjects/CommercialProjects';

class Home extends Component {
    render() {
        return (
    <Auxi>
        <Showcase />
        <About />
        <Experience />
        <PersonalProjects />
        <CommercialProjects />
    </Auxi>
        )
    }

hashLinkScroll()  {
    const hash = this.props.location.hash;
    if(hash) {
        let sectionHash = hash.substr(1,hash.length);
        const element = document.getElementById(sectionHash);
        if(element) {
            element.scrollIntoView()
            const yOffset = -80; 
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
        }
    }
}


componentDidMount() {
    this.hashLinkScroll();
}

componentDidUpdate() {
    this.hashLinkScroll();
}
}
export default Home; 


// WEBPACK FOOTER //
// ./src/container/Home/Home.js